module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-left-black-48-dp.4c362d11.svg";